module.exports = __webpack_public_path__ + "img/help1.46852e01.jpg";